module.exports = __webpack_public_path__ + "static/media/IMG_20160726_182706.440c16ca.jpg";